var map = {
	"./": 59,
	"./App": 45,
	"./App.css": 129,
	"./App.test": 133,
	"./App.test.tsx": 133,
	"./App.tsx": 45,
	"./assets/img/arrow-green.png": 520,
	"./assets/img/arrow-red.png": 521,
	"./assets/img/stripes-cross-icon.png": 522,
	"./assets/img/stripes-icon.png": 523,
	"./components/Background": 31,
	"./components/Background.test": 183,
	"./components/Background.test.tsx": 183,
	"./components/Background.tsx": 31,
	"./components/Bottom/Footer": 83,
	"./components/Bottom/Footer.css": 184,
	"./components/Bottom/Footer.tsx": 83,
	"./components/Bottom/FooterIcon": 33,
	"./components/Bottom/FooterIcon.tsx": 33,
	"./components/Bottom/IFooterIconParams": 185,
	"./components/Bottom/IFooterIconParams.tsx": 185,
	"./components/Bottom/IFooterParams": 186,
	"./components/Bottom/IFooterParams.tsx": 186,
	"./components/Color": 6,
	"./components/Color.tsx": 6,
	"./components/Figure": 56,
	"./components/Figure.tsx": 56,
	"./components/IVizualizationParams": 187,
	"./components/IVizualizationParams.tsx": 187,
	"./components/Left/ColorButtonPalette": 80,
	"./components/Left/ColorButtonPalette.css": 130,
	"./components/Left/ColorButtonPalette.tsx": 80,
	"./components/Left/IColorButtonPaletteParams": 188,
	"./components/Left/IColorButtonPaletteParams.tsx": 188,
	"./components/Left/IWidthButtonParams": 189,
	"./components/Left/IWidthButtonParams.tsx": 189,
	"./components/Left/Left.css": 131,
	"./components/Left/LeftPanel": 79,
	"./components/Left/LeftPanel.tsx": 79,
	"./components/Left/WidthButton": 81,
	"./components/Left/WidthButton.tsx": 81,
	"./components/Palette": 34,
	"./components/Palette.tsx": 34,
	"./components/PlaceOfSignature": 84,
	"./components/PlaceOfSignature.tsx": 84,
	"./components/QrCode": 85,
	"./components/QrCode.css": 194,
	"./components/QrCode.tsx": 85,
	"./components/Right/IStripeButtonParams": 195,
	"./components/Right/IStripeButtonParams.tsx": 195,
	"./components/Right/Right.css": 196,
	"./components/Right/StripeButton": 86,
	"./components/Right/StripeButton.css": 197,
	"./components/Right/StripeButton.tsx": 86,
	"./components/Stripe": 32,
	"./components/Stripe.tsx": 32,
	"./components/StripeWidthList": 87,
	"./components/StripeWidthList.tsx": 87,
	"./components/Top/Header": 82,
	"./components/Top/Header.css": 132,
	"./components/Top/Header.tsx": 82,
	"./components/Top/IHeaderParams": 198,
	"./components/Top/IHeaderParams.tsx": 198,
	"./components/Vizualization": 35,
	"./components/Vizualization.tsx": 35,
	"./externals.d": 199,
	"./externals.d.ts": 199,
	"./index": 59,
	"./index.css": 128,
	"./index.tsx": 59,
	"./logo.svg": 533,
	"./react-app-env.d": 200,
	"./react-app-env.d.ts": 200,
	"./reportWebVitals": 88,
	"./reportWebVitals.ts": 88,
	"./setupTests": 201,
	"./setupTests.ts": 201,
	"./utils/IConfig": 89,
	"./utils/IConfig.ts": 89,
	"./utils/IQueryParamsHelperParams": 224,
	"./utils/IQueryParamsHelperParams.ts": 224,
	"./utils/queryParamsHelper": 36,
	"./utils/queryParamsHelper.ts": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;